module.exports = __webpack_public_path__ + "img/pages-3d.b0c713d3.png";